const translations = {
    selectUas: 'Select Applicable UAS'
};

export default translations;
